import parse from "parse-duration";
export var parseTimeUnit = function (value, includeOther) {
    if (includeOther === void 0) { includeOther = true; }
    if (value) {
        var splitValues = value.split(" ");
        switch (splitValues[splitValues.length - 1].toLowerCase()) {
            case "minutes":
                return ({ value: value.replace("minutes", "").trim(), unit: "minutes" });
            case "hours":
                return ({ value: value.replace("hours", "").trim(), unit: "hours" });
            default:
                return ({ value: value.replace("other", "").trim(), unit: includeOther ? "other" : "minutes" });
        }
    }
    else {
        return ({ value: undefined, unit: includeOther ? "other" : "minutes" });
    }
};
export var parsePeriodTimeUnit = function (value) {
    if (value) {
        try {
            var valueInHours = parse(value, "h");
            var valueInMinutes = parse(value, "m");
            if (valueInHours && valueInHours % 1 === 0) {
                return ({ value: valueInHours.toString(), unit: "hours" });
            }
            else if (valueInMinutes && valueInMinutes % 1 === 0) {
                return ({ value: valueInMinutes.toString(), unit: "minutes" });
            }
            else {
                return ({ value: undefined, unit: "minutes" });
            }
        }
        catch (error) {
            console.error("Unable to parse duration", error);
            return ({ value: undefined, unit: "minutes" });
        }
    }
    else {
        return ({ value: undefined, unit: "minutes" });
    }
};
export var parseTimeUnitPeriod = function (value) {
    var _a, _b;
    var hours = 0;
    var hourRegExp = new RegExp(/[0-8]+H/);
    var matchedHourString = (_a = value.match(hourRegExp)) === null || _a === void 0 ? void 0 : _a[0];
    if (matchedHourString) {
        hours = parseInt(matchedHourString.replace("H", ""));
    }
    var minutes = 0;
    var minutesRegExp = new RegExp(/[0-8]+M/);
    var matchedMinutesString = (_b = value.match(minutesRegExp)) === null || _b === void 0 ? void 0 : _b[0];
    if (matchedMinutesString) {
        minutes = parseInt(matchedMinutesString.replace("M", ""));
    }
    if (hours === 0) {
        return ({ value: minutes.toString(), unit: "minutes" });
    }
    else if (minutes === 0) {
        return ({ value: hours.toString(), unit: "hours" });
    }
    else {
        minutes = minutes + (hours * 60);
        return ({ value: minutes.toString(), unit: "minutes" });
    }
};
//# sourceMappingURL=parser.js.map